import React from "react";

const Header = () => {
    return(
        <header>
            <h1>NICOLÁS MÁRQUEZ</h1>
            <h2>Full Stack Web Developer</h2>
            <p className="typing">Apasionado por la informática y la programación</p>
            <button><a href="#main">Ver más</a></button>
        </header>
    )
}

export default Header